/**
 * @fileoverview Free's room for plants in the garden being tended, from the billing status
 * (access.limits.plants): on Free (a trial or subscription that ended), how
 * many plants Free is up to and how many more fit. Not on Free, or not
 * known yet: unlimited. Read by FreeRoomChoice's callers (the seed packets
 * sheet, and in Add photos the seed packets card and a photo of several
 * kinds).
 *
 * API: GET /billing/status (through useBilling), access.limits.plants.
 * Settings: trial.FREE_PLANTS on the server (5): the limit is only ever the
 * server's; before the status arrives it is not known (0), and the room is
 * unlimited, so no line names it.
 *
 * @module useFreeRoom
 */

import { useBilling } from './useBilling';

/** Free's room for plants in the garden being tended. */
export interface FreeRoom {
  /** On Free: adding is limited to the room. */
  limited: boolean;
  /** Up to how many plants Free has, as the server says; 0 before the status arrives (nothing is limited then, so nothing says it). */
  limit: number;
  /** How many more fit; meaningful only when limited. */
  room: number;
}

/**
 * Free's room for plants, from the billing status. Unlimited until known.
 *
 * @returns The room.
 */
export function useFreeRoom(): FreeRoom {
  const { data } = useBilling();
  const plants = data?.access.limits?.plants;
  if (!plants?.limited) return { limited: false, limit: plants?.limit ?? 0, room: Number.POSITIVE_INFINITY };
  return { limited: true, limit: plants.limit, room: Math.max(0, plants.room ?? 0) };
}
